module.exports = __webpack_public_path__ + "static/media/iconProfile.96f49d83.svg";